export const onUserResumeDataExtraction = /* GraphQL */ `
  subscription OnUserResumeDataExtraction($identity_username: String!) {
    onUserResumeDataExtraction(identity_username: $identity_username) {
      identity_username
      data
    }
  }
`;
